import { Injectable } from '@angular/core'
import { HttpClient } from '@angular/common/http'
import { Observable } from 'rxjs/Observable'
import { environment } from '../../../environments/environment'

export interface NbPartner {
  id: number
  partner: string
  client_id: string
  logo: string
  background_image: string
  background_color?: string
  font_color?: string
  button_color?: string
  button_fontcolor?: string
  client_secret: string
  plain_title: string
  bold_title: string
  active?: boolean
  background_image_iphone?: string
  background_image_iphonex?: string
  background_image_ipad?: string
  PartnerGenre?: NbPartnerGenre[]
  Membershipsource?: NbMembershipsource[]
}

export interface NbPartnerGenre {
  id: number
  partner_id: number
  genre_id: number
  partner_name: string
  partner_image: string
  image: string
  description: string
  partner_image_url?: string
  ordering: number
}

export interface NbMembershipsource {
  id: number
  membership_id: number
  name: string
  price: string
  currenty: string
  trial_num: string
  trial_period: string
}

export interface NbPartnersResponse {
  success: boolean
  partners: NbPartner[]
}

export interface NbPartnerResponse {
  success: boolean
  partner: NbPartner
}

export interface NbPartnerSuccessResponse {
  success: boolean
  message?: string
  partner?: NbPartner
}

export interface NbPartnerGenreSuccessResponse {
  success: boolean
  message?: string
  genre?: NbPartnerGenre
}

@Injectable()
export class PartnerService {
  private API_ENDPOINT = `${environment.HOST}/adminapi/partner/`

  constructor(private http: HttpClient) {}

  public getAllPartners(): Observable<NbPartnersResponse> {
    return this.http
      .get(`${this.API_ENDPOINT}get`)
      .map(res => res as NbPartnersResponse)
  }

  public getPartnerByID(id: number): Observable<NbPartnerResponse> {
    return this.http
      .get(`${this.API_ENDPOINT}getpartner/id/${id}`)
      .map(res => res as NbPartnerResponse)
  }

  public reorderGenre(id: number, ordered: Array<any>): Observable<NbPartnerResponse> {
    return this.http
      .post(`${this.API_ENDPOINT}reorderpartnergenres/id/${id}`, ordered)
      .map(res => res as NbPartnerResponse)
  }

  public savePartner(partner: NbPartner): Observable<NbPartnerSuccessResponse> {
    return this.http
      .post(`${this.API_ENDPOINT}save`, partner)
      .map(res => res as NbPartnerSuccessResponse)
  }

  public deletePartner(id: number): Observable<NbPartnerSuccessResponse> {
    return this.http
      .get(`${this.API_ENDPOINT}delete/id/${id}`)
      .map(res => res as NbPartnerSuccessResponse)
  }

  public deletePartnerLogo(id: number): Observable<NbPartnerSuccessResponse> {
    return this.http
      .get(`${this.API_ENDPOINT}deletelogo/id/${id}`)
      .map(res => res as NbPartnerSuccessResponse)
  }

  public deleteGenre(id: number): Observable<NbPartnerSuccessResponse> {
    return this.http
      .get(`${this.API_ENDPOINT}deletegenre/id/${id}`)
      .map(res => res as NbPartnerGenreSuccessResponse)
  }
}



// WEBPACK FOOTER //
// /srv/dev/FitRadioAdmin2/src/app/@core/data/partner.service.ts